export default __webpack_public_path__ + "static/media/medium.8de359b5.png";